// TopHeader.jsx
import React, { useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';


export default function TopHeader() {
  const { user, userProfile, profileLoading } = useAuth();
  const navigate = useNavigate();
  const isComposingRef = useRef(false); 

  
  console.log('TopHeader - Auth state:', { user: !!user, userProfile, profileLoading });
  
  const getDisplayName = () => {
    if (profileLoading) return "読み込み中...";
    if (userProfile?.name) {
      return userProfile.name;
    }
    if (user?.email) {
      return user.email.split('@')[0];
    }
    return "ユーザー";
  };
  return (
    <div className="top-header">
      <div className="greeting">
        <h2>Hello {getDisplayName()} 👋</h2>
        <p>今日は何か新しいことを学びましょう！</p>
      </div>

      <div className="header-actions">
      <form
          className="search-container"
          onSubmit={(e) => {
            e.preventDefault();
            if (isComposingRef.current) return; // 変換中のEnterは無視
            navigate('/videolist');
          }}
        >
          <input
              type="text"
              placeholder="動画を検索する"
              className="input"
              onCompositionStart={() => (isComposingRef.current = true)}
              onCompositionEnd={() => (isComposingRef.current = false)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !isComposingRef.current) {
                  e.preventDefault();
                  navigate('/videolist');
                }
              }}
          />
          <button type="button" className="notification-button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="icon"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
              ></path>
            </svg>
            <div className="badge">
              <div className="badge-ping"></div>
            </div>
          </button>
        </form>
      </div>
    </div>
  );
}